import './BottomNavigationHelper.scss';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Button } from 'src/modules/common/components/Button';
import { ArrowLeftIcon } from 'src/modules/common/icons/ArrowLeftIcon';
import { ArrowRightIcon } from 'src/modules/common/icons/ArrowRightIcon';

type Props = {
  routeBackText?: string;
  routeBackPath?: string;
  routeForthText?: string;
  routeForthPath?: string;
  nextRouteDisabled?: boolean;
};

export const BottomNavigationHelper = memo(({
  routeBackText,
  routeBackPath,
  routeForthText,
  routeForthPath,
  nextRouteDisabled,
}:Props) => (
  <div className="bp-bottom-navigation-helper">
    {(routeBackPath && routeBackText) && (
      <Button
        kind="ghost"
        as={Link}
        to={routeBackPath}
        size="md"
      >
        <div className="bp-bottom-navigation-helper__button-icon">
          <ArrowLeftIcon/>
        </div>

        <FormattedMessage id="common/bottomNavigation/back" values={{ backText: routeBackText }}/>
      </Button>
    )}
    {(routeForthPath && routeForthText) && (
      <Button
        className="bp-bottom-navigation-helper__forth-button"
        as={Link}
        to={routeForthPath}
        size="md"
        disabled={nextRouteDisabled}
      >
        <FormattedMessage id="common/bottomNavigation/forth" values={{ forthText: routeForthText }}/>

        <div className="bp-bottom-navigation-helper__button-icon">
          <ArrowRightIcon/>
        </div>
      </Button>
    )}

  </div>
));
